import { ErrorIcon } from '@monorepo/shared/componentsV2/errorDisplays/ErrorIcon';
import { IconSlotCell } from '@monorepo/shared/componentsV2/Table/IconSlotCell';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import { bodyMedium } from '@monorepo/shared/styles/text';
import React from 'react';
import styled from 'styled-components';
import { LimitColumnValue } from '../resultsMapper';

const NO_LIMIT_MESSAGE = 'No limit';

function getLabel(props: { minThreshold?: string; maxThreshold?: string }) {
  const { minThreshold, maxThreshold } = props;
  if (minThreshold == null && maxThreshold == null) return NO_LIMIT_MESSAGE;
  const isRange = minThreshold !== undefined && maxThreshold !== undefined;
  const isMax = minThreshold === undefined && maxThreshold !== undefined;
  if (isRange) return `${minThreshold} - ${maxThreshold}`;
  if (isMax) return `≤ ${maxThreshold}`;
  return `≥ ${minThreshold}`;
}

const StyledCell = styled(IconSlotCell)<{ $isExceedance: boolean }>`
  white-space: nowrap;
  ${({ $isExceedance, theme }) =>
    $isExceedance ? `${bodyMedium}; color: ${theme.colors.darkRed};` : ''}
  & svg {
    margin-right: 0.25rem;
  }
`;

export const LimitTableCell = ({
  value: { minThreshold, maxThreshold, isExceedance },
}: {
  value: LimitColumnValue;
}) => (
  <StyledCell
    $isExceedance={isExceedance}
    icon={
      <>
        <ErrorIcon />
        <VisuallyHidden>Is Exceedance</VisuallyHidden>
      </>
    }
    isIconVisible={isExceedance}
  >
    {getLabel({ minThreshold, maxThreshold })}
  </StyledCell>
);
